module.exports = __webpack_public_path__ + "hyperion-v2-static/img/hiscox_cr_logo.b981108f.jpg";